import { render, staticRenderFns } from "./ProtocolChart.vue?vue&type=template&id=bd0ca46a&scoped=true&"
import script from "./ProtocolChart.vue?vue&type=script&lang=js&"
export * from "./ProtocolChart.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolChart.vue?vue&type=style&index=0&id=bd0ca46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0ca46a",
  null
  
)

export default component.exports